import React from 'react';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';

const Layout = ({ user, onLogout, children, validacaoCount }) => {
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar — visível apenas no desktop */}
      <div className="hidden lg:flex">
        <Sidebar
          user={user}
          onLogout={onLogout}
          mobileOpen={false}
          setMobileOpen={() => {}}
          validacaoCount={validacaoCount}
        />
      </div>

      {/* Conteúdo principal */}
      <main className="flex-1 overflow-y-auto">
        {/* padding-bottom no mobile para não ficar atrás do BottomNav */}
        <div className="max-w-[1920px] mx-auto pb-20 lg:pb-0">
          {children}
        </div>
      </main>

      {/* Bottom Navigation — apenas mobile */}
      <BottomNav user={user} onLogout={onLogout} />
    </div>
  );
};

export default Layout;
